export default "__VITE_ASSET__DOt_V3mu__"